import { render, staticRenderFns } from "./CCMMedicalNoteAdd.vue?vue&type=template&id=a1a9a77e"
import script from "./CCMMedicalNoteAdd.vue?vue&type=script&lang=js"
export * from "./CCMMedicalNoteAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports